import BaseService from "@/services/BaseService";

export default class CoverageDescriptionService extends BaseService {
  constructor() {
    super('odoo/coverage');
  }

  findAll() {
    return this.http.get(`${this._serviceName}/descriptions`);
  }

  save(data) {
    return this.http.post(`${this._serviceName}/description`, data);
  }
}
